import React from "react";
import { Trans } from "@lingui/macro";
import * as styles from "./ContactUs.module.scss";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { Icon } from "@silversea-ssc/ui-components-react";

const ContactUs: React.FC = () => {
  const geolocation = useGeolocation();
  const { phone: phoneNumber, phoneDisclaimer } = geolocation;

  return (
    <React.Fragment>
      {phoneNumber && (
        <div className={styles.contactUsContainer}>
          <div className={styles.contactUs}>
            <div className={styles.label}>
              <Trans>Call our Reservation Team</Trans>
            </div>
            <div className={styles.phoneNumber}>
              <a href={`tel:${phoneNumber}`} data-content-piece="phone">
                <Icon name="phone" size="1.5x" padding={false} /> {phoneNumber}
              </a>
              {phoneDisclaimer && (
                <div className={styles.phoneNumberDisclaimer}>
                  {phoneDisclaimer}
                </div>
              )}
            </div>
          </div>
          <div className={styles.labelTravelAgent}>
            <Trans>or contact your travel agent</Trans>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ContactUs;
